import React from "react";
import {
  Container,
  VStack,
  Heading,
  Grid,
  GridItem,
  Box,
  Text,
  Image,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { FaUser } from "react-icons/fa";
import { useTournament } from "../contexts/TournamentContext";

const getJokeKey = (player, year) => {
  if (year === "2025") {
    if (player === "Aaron Campbell") return "Aaron Campbell";
    return player;
  }
  if (player === "Ryan Opie") return "R. Opie";
  if (player === "Aaron Campbell") return "Aaron Campbell";
  if (player === "Aron Campbell") return "Campbell";
  if (player === "Ellis Opie") return "Ellis";
  if (player === "Brett Opie") return "Opie";
  if (player === "Rob Stanisz") return "Stanisz";
  return player.split(" ").pop();
};

// Bios for 2025 archive players (keyed by joke key from getJokeKey)

const playerJokes2025 = {
  Worlidge:
    "D1 lacrosse player, paint enthusiast, and 2-time AR champion. Matt's always \"ouuuuttttt\" when plans come up… unless it's the AR weekend. That's where he thrives. Known to repeat a joke 78346387286 times, Matt also has the ability to carry his teammates to victory in any tournament. He's done it twice already! Will he win his 3rd title this year and pursue golf full time? Or will he lose and be stuck pursuing other business opportunities?",
  Campbell:
    "Quite possibly the best athlete his high school has ever seen. Basketball, football, soccer, this guy is an absolute force. The one sport he stinks at? Golf. That doesn't mean he can't win though. He's got an elite athlete mentality, carries three 7 irons in his bag and is paired with the top player in the tournament! If he loses? Chalk it up to a conspiracy theory.",
  "O'Brien":
    "Everybody's favourite uncle. This 6'5 bag of milk/blackout accounting genius is one of the most decorated golfers in the tournament. Collecting 3 AR championships over his career, Dob is known for his massive slice off the tee and feathered touch around the greens, Nobody's got a slice like Dobs. If paired with the right partner, could this big lefty capture his 4th title? Mhmmm!",
  Mason:
    "Mail Man, tool man, tree trimmer, fine connoisseur of spicy food and breast milk. Shockingly to anyone who's golfed with him, Mason is the most recent AR Champion, adding \"winner\" to his chaotic resume. Although Brandon wears many hats, he rarely wears a clean shirt, as he loves to rock the same outfit for the entire tournament. Let's play my game!",
  Bajzik:
    "A longtime AR staple, Chubbs is built like a gazelle, swings like a Tasmanian devil, and dresses like he's late for a yacht club meeting. Though he's yet to secure a win, he's always in the hunt. With a strong jaw, swagger of a Hamilton DILF and a heroic past (he once saved kids from a fire in Cuba!), how can you not root for him? Freshly married, he's aiming to make his wedding the second best day of 2025—with an AR win.",
  Flanagan:
    "This former Canadian University basketball player and newly adopted Italian is living proof that height doesn't always equal distance. Known on the course as The Arborist, Ryan's drives may not go far, but they always find a way to knock down tree limbs. Known off the course as Mr. Proportional, \"we'll see\" if he has what it takes to capture his first ever AR win.",
  Cornford:
    'A three-time AR "champion," Groom has perfected the art of winning while doing the least—twice by expertly riding coattails, which he considers a talent, not a flaw. Best known for his "wrap-around" golf swing, currently under study by both physicists and chiropractors. He also has a putting routine that\'s equal parts majestic and excruciatingly slow. Eventually, when he putts, you\'ll hear him shout, "BANG!" Whether it\'s tracking or not.',
  Stanisz:
    "Proud owner of the tournament's best barrel, Rob is a golf ball assassin. He can smash it 300 yards and swings so hard he throws his back out every 4-6 weeks. When he's not at the course, Rob can be found letting in goals through his legs as Burlington's premier E division beer league goalie. Now he looks to capture a win in his first ever AR Invitational.",
  Atkinson:
    "Two-time Allan Cup champ with the Dundas Real McCoys, Atko is a hockey player who's playing golf today. One of only three players to have teed it up at every single AR and a 3-time champ, he can absolutely crush it off the tee… but don't ask him to chip. He can't even get it off the ground. The only thing longer than his drives is his forehead. Will this be the year he adds a 4th title or will putting from everywhere be his downfall?",
  Robertson:
    "A fresh American import who skipped dental school (sorry, Dad) and always makes sure to drink milk with dinner. On the golf course, Jason is legit. The guy can play. With a new home golf simulator, his game has only gotten better. Now he looks to capture his second career AR title. Just as long as he doesn't get distracted talking about the best sunset in North America.",
  Opie: "Meet Brett – professional anthem singer and the only player willing to sweat through his ass to play 18 holes in August. Why? Because he'll only golf in pants, never shorts. And for a shirt? Kirkland brand tees only. Why? Because just like Brett, they're resilient, white and built stronger than the rest. After about ten 2nd place finishes, it would be DURLY if he could get his first win.",
  Cancilla:
    'Drives like Rory, grooms like a Kardashian. Nick\'s got both the best swing and the best eyebrows in the tournament. Expect this one-time AR *champion* to roll up to the first tee in a black Range Rover, blasting the Gypsy Kings greatest hits. Nick hates travelling, but loves being there, especially if "there" involves beers and male nudity. Can he capture his second career win? Or will his chicken delivery be late again?',
  Myers:
    "No lips? No ass? No problem. This 2-time AR Champion and Minor Hockey Day MVP might have the best ball flight in the tournament. As the Manager of one of the top restaurants in the GTA, Mac is the only person in this tournament who regularly stresses about napkins. Can he dial it in and capture his 3rd career title? Or will he doo doo doo too many practice swings and come last?",
  Schwehr:
    "You're looking at the top player in the tournament folks. He hits the ball a mile, has elite control around the greens and talks faster than an auctioneer at an espresso bar. He's the only person in the tournament that will drive up to the first tee in a Lambo, hit a drive, then tell you a story before it lands. Can he handle the pressure of being the #1 seed?",
  Cochrane:
    "He may be allergic to everything, complain about everything and have vision so blurry that his glasses need glasses, but when he gets hot, he gets hot. This guy can put up an 85 on any given day…orrrr a 120. You never know what you're gonna get. Don't believe me? Look up the 2001 Tyandaga Junior Open. 83 on day one, 125 on day two. Absolute master class. Could this be the year Tyler finally arrrgh's his way to an AR win?",
  Fobert:
    "Once crowned Athlete of the Year at a high school that clearly had no other options, Fobes has traded in wind sprints for ice cold beers. The only injury he has to worry about now is getting red in the face after each drink. As a former employee at Tucker's Marketplace, John definitely has the toughness to win in his first ever AR Invitational.",
  Petrie:
    "Originally selected in the 15th round of the 2008 OHL Priority Selection (291st overall), Petrie is this tournament's full-time wild card. He's fallen off mountains, rented hats, traveled great distances without warning and has considered almost every profession in the world. Now, Petrie brings his fearless energy and capri pants to his first-ever AR Invitational.",
  Ellis:
    "Joining the AR ranks in 2022, Ellis has cemented himself as a mainstay in the tournament, especially after claiming his first victory last year. As the CEO of Rizzno's, Ellis always has pepperonis on him and demands NO CHIRPING ON THE TEE BLOCKS. Relying heavily on his rangefinder and awful pick up lines, Ellis has a legitimate shot to defend his title.",
  "R. Opie":
    "The third Opie to join the party—and easily the biggest diva. He's not Italian, but it still takes him 25 minutes to do his hair. Off the course, you'll never catch him in anything but black; on the course, it's the only time his outfit lightens up—unlike his attitude. Ryan had thoughts about the tournament format, but let's be honest: he's not nearly good enough at golf to be that opinionated.",
  "Aaron Campbell":
    "This year's short bald king. Don’t let the height fool you—Soupy’s drives are as bold as his betting slips. A proud tech sales warrior by day and a slot machine slut by night, he’s always chasing the next big win—whether it’s a commission check or a miracle birdie after a triple bogey. This is his first-ever AR Invitational.",
};

const playerJokes2026 = {
  "Matt Schwehr":
    "The undisputed #1 golfer in the field, Matt takes golf so seriously he drives a Volkswagen Golf that's somehow lower than his handicap. Do you like sleeve tattoos?  He's got those too!  Matts got the swag to win the tournament, but can he handle the pressure?",
  "Connor Bunn":
    "Nobody brings more volume to the course than Connor, who treats every AR like a debate club championship. As a professional skateboard video game player, and former bearded-lady, he doesn't have much time for golf.  But he's got lots of time for being a good teammate, and that's what wins you championships.",
  "Nick Cancilla":
    "The tournament's second-best golfer absolutely launches the ball... and occasionally his blood pressure. Between planning this year's event, keeping his Range Rover spotless, and making sure his eyebrows stay on fleek, Nick has a lot on his mind. Thankfully, his driver doesn't seem to notice.",
  "Aron Campbell":
    "Built like he should be competing in the Olympics, Aron is easily the best athlete in the tournament—just don't ask him to prove it on a golf course. Armed with three 7-irons for reasons known only to him and confidently wearing jean shorts to the course, he's proof that confidence can carry you almost anywhere.",
  "Matt Worlidge":
    "A legitimate stick on the course and a former NCAA lacrosse player, Matt's memory of irrelevant facts is somehow even sharper than his golf game. He remembers things from elementary school with alarming accuracy and has a nickname for absolutely everyone—including his newborn. If you've met Matt, you've probably forgotten your own real name.",
  "John Odame":
    "Built like an action hero but swings a golf club like it's his first day on Earth. John's dance moves are so iconic that he was once asked to join a male stripper service called Black Thunder.  You would swear he had rhythm.  He remains deeply committed to one thing: never fully committing to anything.",
  "Ellis Opie":
    "Ellis is one of the better golfers in the field, which is fortunate because his pickup lines have never gotten him anywhere. He somehow finds time to do laundry on a three-day vacation and insists everyone call him \"Jefe.\" No one does—but he hasn't stopped trying.",
  "Austin Hawke":
    "A former undersized high school linebacker, Stu looks like a dinosaur in human form. He's also the only guy who could accidentally jam an EpiPen into his own thumb and live to tell the story. His golf game isn't nearly as dangerous—but it's just as unpredictable.",
  "Trevor Bajzik":
    "Growing up, Chubbs had an olive oil smooth swing.  Now, he swings like the golf ball owes him money—and somehow, it usually ends up in the fairway.  One of the better golfers in the field, he's easy to spot in his signature yacht club attire complete with khaki shorts and a yellow shirt.",
  "Brett Opie":
    "The least annoying Opie in the tournament somehow also ended up with all the height. Brett sells tires, loves his cat, and starts every morning at Tim Hortons—where they somehow mess up his order every single day. He keeps going back anyway, making him the tournament's most loyal customer. He's too invested to quit now.",
  "John Fobert":
    "A former Athlete of the Year at a high school that wasn't exactly overflowing with future Olympians, Fobes still carries himself like a champion. He proudly attended Ottawa University and, after a couple of drinks, turns a shade of red usually reserved for emergency exit signs. Thankfully, his golf game cools him off eventually.",
  "Ryan Flanagan":
    "A former university basketball player, Flan has found his way into an Italian family and has never looked back. He's traded Irish cuisine for homemade pasta, spends his evenings defending the garden from raccoons, and has quietly transformed into a full time Nonna.  \"We'll see\" if he can capture his first AR championship.",
  "Mac Myers":
    "Mac manages one of the best restaurants in the GTA and treats a pepper grinder like part of the dress code. He's a member at a fancy country club, crushes the golf ball, and somehow generates all that power with no ass whatsoever. Living proof that horsepower doesn't always need rear-wheel drive.",
  "Tyler Cochrane":
    "Tyler's golf swing starts off his back foot, his running style looks physically impossible, and his eyesight raises legitimate safety concerns. Yet somehow, against all available evidence, he'll quietly post an 85. Scientists have studied less confusing phenomena.",
  "Brandon Petrie":
    "Originally selected 291st overall in the 2008 OHL Priority Selection, Petrie has spent a lifetime proving draft position isn't everything. When it's time to dress up, out comes the extra-deep V-neck. He'll also show up at your front door completely unannounced, hoping to talk about his next career or the latest in landscaping.",
  "Brandon Mason":
    "Once described by somebody in this tournament as \"Ugly Fennell,\" Mason sells tools for a living. He firmly believes every profession is easy—as long as you just try your best. It's the kind of career advice that only someone outside your industry can provide.  I wonder if that advice applies to golf?",
  "Connor Johnston":
    "CJ lives life like every day is an action movie. When he's not jumping out of airplanes or ripping around on his motorcycle, he's launching golf balls into the next postal code. Add in an elite mullet, and he's proof that poor decisions can occasionally produce outstanding results.",
  "Ryan Heine":
    "A real estate agent by trade and a former rugby player by nature, Heine is built like an XL fire hydrant. Short, wide, and tough, he's the definition of an absolute unit. If you don't hear him on the golf course, don't worry—you'll hear him snoring from three houses away.",
  "Ryan Opie":
    "Ryan experiences every inconvenience like it's a national emergency. Everything is either the best he's ever seen or the worst he's ever seen, with absolutely no middle ground. He still spikes his hair with gel like it's 2004, and if you're looking for anti-aging cream made from salmon... he's your guy.",
  "Dylan O'Brien":
    "A 6'5\" lefty with Trudeau-level hair, DOB knows how to win—three-time AR champion and more fantasy hockey titles than he can count. Rumour has it the Leafs called about their GM opening, but they couldn't hear him when he answered the phone.  His driver, on the other hand, has no trouble making itself known two fairways over.",
  "Trevor Atkinson":
    "Atko hits absolute missiles off the tee, then immediately gives every stroke back around the green. A hockey player with a forehead you could project a movie onto and a dump truck that deserves its own parking spot, he's convinced stand-up comedy is his backup plan. The audience remains unconvinced.",
  "Graham Cornford":
    "Groom's wrap-around golf swing has confused instructors for years, but somehow his putter always bails him out. If he shoots a 94, he'll tell you he's \"absolutely dialed.\" When he's not sinking putts, you'll find him starring in another TikTok with his wife.",
  "Aaron Campbell":
    "The defending tournament champion proves you don't need height to win—just confidence. A proud short bald king and tech sales pro, Soupy spends his free time chasing jackpots on Buffalo Ascension. Fortunately for the rest of the field, golf tournaments aren't won with free spins.",
  "Rob Stanisz":
    "Rob is the defending tournament champion with one of the best barrels in the field. A beer league goalie with the reflexes of a traffic cone, he prefers the safety of his couch and video games over the outdoors. Luckily, golf carts count as fresh air.",
};

const getPlayerBio = (player, year) => {
  const defaultBio =
    "The mysterious golfer who lets their clubs do the talking.";
  if (year === "2025") {
    const jokeKey = getJokeKey(player, year);
    return playerJokes2025[jokeKey] || defaultBio;
  }
  return playerJokes2026[player] || defaultBio;
};

const arChampionshipWins2026 = {
  "Nick Cancilla": 1,
  "Matt Worlidge": 2,
  "John Odame": 1,
  "Ellis Opie": 1,
  "Austin Hawke": 2,
  "Mac Myers": 2,
  "Brandon Mason": 1,
  "Connor Johnston": 2,
  "Dylan O'Brien": 3,
  "Trevor Atkinson": 3,
  "Graham Cornford": 3,
  "Aaron Campbell": 1,
  "Rob Stanisz": 1,
};

const getTrophyEmojis = (player, year) => {
  if (year === "2025") return "";
  const wins = arChampionshipWins2026[player] || 0;
  return wins > 0 ? " " + "🏆".repeat(wins) : "";
};

const getTeamImageSrc = (imageFile, year) => {
  if (!imageFile) return null;
  const folder = year === "2025" ? "team_images_2025" : "team_images";
  return `/data/${folder}/${imageFile}`;
};

const PlayerCard = ({ player, imageFile, ranking, year }) => {
  const bio = getPlayerBio(player, year);
  const trophies = getTrophyEmojis(player, year);
  const imageSrc = getTeamImageSrc(imageFile, year);

  return (
  <Box
    bg="green.700"
    p={4}
    borderRadius="lg"
    _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
  >
    <VStack spacing={4} align="stretch">
      {imageSrc ? (
        <Image
          src={imageSrc}
          alt={player}
          borderRadius="md"
          objectFit="cover"
          height="500px"
          width="100%"
        />
      ) : (
        <Flex
          height="500px"
          width="100%"
          bg="green.800"
          borderRadius="md"
          align="center"
          justify="center"
        >
          <Icon as={FaUser} boxSize={16} color="green.600" />
        </Flex>
      )}
      <Box>
        <Heading size="md">
          {player}
          {trophies}
        </Heading>
        <Text mt={2} fontSize="sm" color="gray.300">
          Golfer
        </Text>
        {ranking > 0 && (
          <Text mt={1} fontSize="xs" color="yellow.400" fontWeight="bold">
            AR Pre-Tournament Ranking: #{ranking}
          </Text>
        )}
        {ranking === 0 && (
          <Text mt={1} fontSize="xs" color="yellow.400" fontWeight="bold">
            Reigning AR Champion
          </Text>
        )}
        <Text mt={3} fontSize="sm" color="gray.300" fontStyle="italic">
          "{bio}"
        </Text>
      </Box>
    </VStack>
  </Box>
  );
};

const TeamSection = ({ team, year }) => (
  <Box mb={8}>
    <Heading size="md" mb={4}>
      {team.name}
    </Heading>
    <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
      {team.players.map((player, index) => (
        <GridItem key={index}>
          <PlayerCard
            player={player}
            imageFile={team.images[index]}
            ranking={team.rankings[index]}
            year={year}
          />
        </GridItem>
      ))}
    </Grid>
  </Box>
);

const PlayersPage = () => {
  const { teams, year, readOnly } = useTournament();

  return (
    <Container maxW="container.lg" py={6}>
      <VStack spacing={8} align="stretch">
        <Heading size="lg">
          {readOnly ? "AR 2025 Players" : "Tournament Players"}
        </Heading>
        {teams.map((team) => (
          <TeamSection key={team.id} team={team} year={year} />
        ))}
      </VStack>
    </Container>
  );
};

export default PlayersPage;
